export const uppercaseFirst = (str: string) => {
    if (str == null) return null;

    return `${str?.[0]?.toUpperCase() ?? ""}${str?.substring(1)?.toLowerCase()}`;
};
